import React, { useState, useEffect } from 'react';
import qs from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { Language, isValidVerificationLink } from '../../../utils';
import { user as userActions } from '../../../actions';

import makeClasses from '../styles';
import { replace } from 'connected-react-router';

const StepFour = ({ traceId, history, onVerificationLinkLoaded }) => {
  const dispatch = useDispatch();
  const classes = makeClasses();

  const { languageTexts } = useSelector(state => ({
    languageTexts: state.language.texts || {},
  }));
  const i18n = Language(languageTexts);

  const initialLink = qs.parse(history.location.search).verificationLink;
  const [affiliationVerificationLink, setAffiliationVerificationLink] = useState(() => {
    if (initialLink && isValidVerificationLink(initialLink)) {
      const decoded = decodeURIComponent(initialLink);
      return decoded;
    }
    return null;
  });

  useEffect(() => {
    if (affiliationVerificationLink) {
      onVerificationLinkLoaded();
      return;
    }

    dispatch(
      userActions.affiliationGetIdentityVerificationLink(traceId, result => {
        const safeLink = result.verificationLink;
        if (isValidVerificationLink(safeLink)) {
          setAffiliationVerificationLink(safeLink);
          onVerificationLinkLoaded();
          const params = qs.parse(history.location.search) || {};
          params.verificationLink = safeLink;
          dispatch(replace({ search: qs.stringify(params) }));
        } else {
          toast.error(i18n.get('AlertInvalidVerificationLink'), { autoClose: 5000 });
        }
      })
    );
  }, []);

  useEffect(() => {
    if (affiliationVerificationLink) {
      const requestCameraPermission = async () => {
        await navigator.mediaDevices.getUserMedia({ video: true });
      };
      requestCameraPermission();
    }
  }, [affiliationVerificationLink]);

  return (
    <React.Fragment>
      <div className={classes.formContent}>
        <div className={classes.formTitleContainer}>
          <div className={classes.formTitle}>{i18n.get('Register.StepFormTitle')}</div>
          <div className={classes.formText}>{i18n.get('Register.Step5FormText')}</div>
        
        </div>
      </div>
      {affiliationVerificationLink ? (
        <div className={classes.iframeContainer}>
          <iframe src={affiliationVerificationLink} title="Verification" allow="camera *;" />
        </div>
      ) : null}
    </React.Fragment>
  );
};

StepFour.id = 'com.Handy.Register.StepFour';
export default StepFour;
